module.exports = __webpack_public_path__ + "img/m8.de6d1d68.jpg";